import { render } from "./ContactForm.vue?vue&type=template&id=160ddea6&ts=true"
import script from "./ContactForm.vue?vue&type=script&lang=ts"
export * from "./ContactForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__